import {
    CREATE_SETTINGS_FAILURE,
    CREATE_SETTINGS_MASTER_USERFORM,
    CREATE_SETTINGS_REQUEST,
    CREATE_SETTINGS_SUCCESS,
    DELETE_SETTINGS_FAILURE,
    DELETE_SETTINGS_REQUEST,
    DELETE_SETTINGS_SUCCESS,
    FETCH_ALL_SETTINGS_DATA_FAILURE,
    FETCH_ALL_SETTINGS_DATA_REQUEST,
    FETCH_ALL_SETTINGS_DATA_SUCCESS,
    FETCH_SETTINGS_DATA_BY_ID_FAILURE,
    FETCH_SETTINGS_DATA_BY_ID_REQUEST,
    FETCH_SETTINGS_DATA_BY_ID_SUCCESS,
    UPDATE_SETTINGS_FAILURE,
    UPDATE_SETTINGS_REQUEST,
    UPDATE_SETTINGS_SUCCESS

} from "./settings.actionType";



export const SETTINGS = 'settings';

let initialState = {
    loading: false,
    settingsData: [],
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedRow: {},
    detailsId: '',
    activeKey: 1,

};

export let settingsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_SETTINGS_DATA_REQUEST:
        case FETCH_SETTINGS_DATA_BY_ID_REQUEST:
        case CREATE_SETTINGS_REQUEST:
        case UPDATE_SETTINGS_REQUEST:
        case DELETE_SETTINGS_REQUEST:

            return {
                ...state,
                loading: true
            };
        case CREATE_SETTINGS_MASTER_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
                headerFields: {
                    ...state.headerFields,
                    [payload.key]: payload.value
                }
            };
        case FETCH_ALL_SETTINGS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                settingsData: updatePayload
            };
        case FETCH_SETTINGS_DATA_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case CREATE_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            }
        case UPDATE_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            }
        case DELETE_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            }

        case FETCH_ALL_SETTINGS_DATA_FAILURE:
        case FETCH_SETTINGS_DATA_BY_ID_FAILURE:
        case CREATE_SETTINGS_FAILURE:
        case UPDATE_SETTINGS_FAILURE:
        case DELETE_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state

    }
}